export default "__VITE_ASSET__D9SXp0ax__"